import {
    accentVariants,
    primaryVariants,
    secondaryVariants,
    setColorVariants,
} from '../../shared/helpers/colorHelper';
import {
    chartColors,
    colorsGlobal,
    customColors,
    desklyColors,
    primitives,
} from '../../shared/mixins/colors';

export default {
    methods: {
        /**
         *
         * @param {AccountForm | false} whitelabelInformation
         * @returns void
         */
        whiteLabelCheck(whitelabelInformation = false) {
            if (whitelabelInformation?.favicon) {
                this.setFavIcon(whitelabelInformation.favicon);
            }

            if (whitelabelInformation?.applicationTitle) {
                this.setTitle(whitelabelInformation.applicationTitle);
            }

            if (whitelabelInformation?.customColors) {
                this.setColors(
                    whitelabelInformation.primaryColor,
                    whitelabelInformation.secondaryColor,
                    whitelabelInformation.hoverColor,
                    whitelabelInformation.kioskBackgroundColor
                );
                return;
            }

            this.setDefaultColors();
        },
        setFavIcon(iconUrl) {
            const favicon = document.querySelector('[rel=icon]');
            if (favicon) {
                favicon.href = iconUrl;
            }
        },
        setTitle(title) {
            document.title = title;
        },
        setGlobalColors() {
            document.documentElement.style.setProperty('--black', colorsGlobal.black);
            document.documentElement.style.setProperty('--black-light', colorsGlobal.blackLight);
            document.documentElement.style.setProperty('--white', colorsGlobal.white);
            document.documentElement.style.setProperty('--gray', colorsGlobal.gray);
            document.documentElement.style.setProperty('--gray-light', colorsGlobal.grayLight);
            document.documentElement.style.setProperty('--warning', colorsGlobal.warning);
            document.documentElement.style.setProperty('--error', colorsGlobal.error);
            document.documentElement.style.setProperty('--error-dark', colorsGlobal.errorDark);
            document.documentElement.style.setProperty('--success', colorsGlobal.success);

            // chart colors
            document.documentElement.style.setProperty(
                '--resources-seat',
                chartColors.resources.seat
            );
            document.documentElement.style.setProperty(
                '--resources-green1',
                chartColors.resources.green1
            );
            document.documentElement.style.setProperty(
                '--resources-green2',
                chartColors.resources.green2
            );
            document.documentElement.style.setProperty(
                '--resources-green3',
                chartColors.resources.green3
            );
            document.documentElement.style.setProperty(
                '--resources-blue',
                chartColors.resources.blue
            );
            document.documentElement.style.setProperty(
                '--resources-zone',
                chartColors.resources.zone
            );
            document.documentElement.style.setProperty(
                '--resources-lila1',
                chartColors.resources.lila1
            );
            document.documentElement.style.setProperty(
                '--resources-lila2',
                chartColors.resources.lila2
            );
            document.documentElement.style.setProperty(
                '--resources-rosa1',
                chartColors.resources.rosa1
            );
            document.documentElement.style.setProperty(
                '--resources-rosa2',
                chartColors.resources.rosa2
            );
            document.documentElement.style.setProperty(
                '--resources-meetingRoom',
                chartColors.resources.meetingRoom
            );
            document.documentElement.style.setProperty(
                '--resources-red',
                chartColors.resources.red
            );
            document.documentElement.style.setProperty(
                '--resources-orange1',
                chartColors.resources.orange1
            );
            document.documentElement.style.setProperty(
                '--resources-orange2',
                chartColors.resources.orange2
            );
            document.documentElement.style.setProperty(
                '--resources-yellow',
                chartColors.resources.yellow
            );

            document.documentElement.style.setProperty(
                '--status-office',
                chartColors.status.office
            );
            document.documentElement.style.setProperty(
                '--status-mobile',
                chartColors.status.mobile
            );
            document.documentElement.style.setProperty(
                '--status-absent',
                chartColors.status.absent
            );

            // primitives
            setPaletteColorVariables('zinc', primitives.zinc);
            setPaletteColorVariables('blue', primitives.blue);
            setPaletteColorVariables('green', primitives.green);
            setPaletteColorVariables('yellow', primitives.yellow);
            setPaletteColorVariables('orange', primitives.orange);
            setPaletteColorVariables('red', primitives.red);
        },
        setColors(primary, secondary, hover, kioskBackground) {
            //dynamic colors
            document.documentElement.style.setProperty('--primary', primary);
            document.documentElement.style.setProperty('--secondary', secondary);

            // add inverse color
            setColorVariants(secondary, 'secondary', {});
            document.documentElement.style.setProperty('--hover', hover);

            // add inverse color
            setColorVariants(hover, 'hover', {});
            document.documentElement.style.setProperty('--active', primary);
            document.documentElement.style.setProperty(
                '--kiosk-mode-background',
                kioskBackground || primary
            );

            setPaletteColorVariables('primary', primitives.zinc);
            setColorVariants(primary, 'primary', primaryVariants);
            setColorVariants('#B8E0E9', 'd-secondary', secondaryVariants);
            document.documentElement.style.setProperty('--d-accent', '#F7711E');
            setColorVariants('#F7711E', 'd-accent', accentVariants);

            //whitelabel colors
            document.documentElement.style.setProperty('--accent', customColors.accent);
            document.documentElement.style.setProperty('--accent-light', customColors.accentLight);
            document.documentElement.style.setProperty(
                '--accent-lighter',
                customColors.accentLighter
            );
            this.setDeprecatedWhitelabelBackgroundColors();

            // booking 2.0 whitelabel colors
            document.documentElement.style.setProperty('--d-secondary', secondary);
            setColorVariants(primary, 'primary', primaryVariants);
            setColorVariants(secondary, 'd-secondary', secondaryVariants);
            document.documentElement.style.setProperty(
                '--d-background',
                customColors.backgroundLighter
            );
        },
        setDeprecatedWhitelabelBackgroundColors() {
            document.documentElement.style.setProperty(
                '--background-lighter',
                customColors.backgroundLighter
            );
            document.documentElement.style.setProperty('--background', customColors.background);
            document.documentElement.style.setProperty(
                '--background-light',
                customColors.backgroundLight
            );
        },
        setDefaultColors() {
            document.documentElement.style.setProperty('--primary', desklyColors.primary);
            document.documentElement.style.setProperty(
                '--secondary',
                desklyColors.secondaryDeprecated
            );
            // add inverse color
            setColorVariants(desklyColors.secondaryDeprecated, 'secondary', {});
            document.documentElement.style.setProperty('--hover', desklyColors.hover);
            // add inverse color
            setColorVariants(desklyColors.hover, 'hover', {});
            document.documentElement.style.setProperty('--active', desklyColors.active);
            document.documentElement.style.setProperty(
                '--kiosk-mode-background',
                desklyColors.kioskBackground
            );

            setPaletteColorVariables('primary', primitives.desklyPrimaryColorPalette);
            setColorVariants(desklyColors.primary, 'primary', primaryVariants);
            setColorVariants('#B8E0E9', 'd-secondary', secondaryVariants);
            document.documentElement.style.setProperty('--d-accent', '#F7711E');
            setColorVariants('#F7711E', 'd-accent', accentVariants);

            document.documentElement.style.setProperty('--accent', desklyColors.accent);
            document.documentElement.style.setProperty('--accent-light', desklyColors.accentLight);
            document.documentElement.style.setProperty(
                '--accent-lighter',
                desklyColors.accentLighter
            );

            this.setDeprecatedBackgroundColors();

            // booking 2.0 colors
            document.documentElement.style.setProperty('--d-secondary', desklyColors.secondary);
            setColorVariants(desklyColors.primary, 'primary', primaryVariants);
            setColorVariants(desklyColors.secondary, 'd-secondary', secondaryVariants);
            document.documentElement.style.setProperty('--d-background', desklyColors.background);
        },
        setDeprecatedBackgroundColors() {
            document.documentElement.style.setProperty(
                '--background',
                desklyColors.backgroundDeprecated
            );
            document.documentElement.style.setProperty(
                '--background-light',
                desklyColors.backgroundLightDeprecated
            );
            document.documentElement.style.setProperty(
                '--background-lighter',
                desklyColors.backgroundLighterDeprecated
            );
        },
        setNewBookingColors(hasWhitelabeling) {
            document.documentElement.style.setProperty('--background-lighter', '#fff');

            // if whitelabeling set, update new background color also
            if (hasWhitelabeling) {
                document.documentElement.style.setProperty('--background', customColors.background);
                document.documentElement.style.setProperty(
                    '--background-light',
                    customColors.backgroundLighter
                );
                return;
            }

            document.documentElement.style.setProperty(
                '--background',
                desklyColors.backgroundDarker
            );
            document.documentElement.style.setProperty(
                '--background-light',
                desklyColors.background
            );
        },
    },
};

function setPaletteColorVariables(name, palette) {
    Object.keys(palette).forEach(number => {
        document.documentElement.style.setProperty(`--${name}-${number}`, palette[number]);
    });
}
